export const dataflowLexerWoAnno = require('../grammar/DataflowLexer.js').DataflowLexer;

export class PreprocessorUtils {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public static readonly openScopeTokens: any[] = [
        dataflowLexerWoAnno.OPEN_PAREN,
        dataflowLexerWoAnno.OPEN_CURLY,
        dataflowLexerWoAnno.OPEN_STRUCT,
        dataflowLexerWoAnno.OPEN_TYPEOF,
        dataflowLexerWoAnno.OPEN_SQ,
        dataflowLexerWoAnno.INTERPOLATE_OPEN_CURLY
    ];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public static readonly closeScopeTokens: any[] = [
        dataflowLexerWoAnno.CLOSE_PAREN,
        dataflowLexerWoAnno.CLOSE_CURLY,
        dataflowLexerWoAnno.CLOSE_SQ
    ];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public static readonly typeNameTokens: any[] = [
        dataflowLexerWoAnno.INTEGER,
        dataflowLexerWoAnno.SHORT,
        dataflowLexerWoAnno.LONG,
        dataflowLexerWoAnno.FLOAT,
        dataflowLexerWoAnno.DOUBLE,
        dataflowLexerWoAnno.DECIMAL,
        dataflowLexerWoAnno.BYTE,
        dataflowLexerWoAnno.BINARY,
        dataflowLexerWoAnno.DATE,
        dataflowLexerWoAnno.BOOLEAN,
        dataflowLexerWoAnno.TIMESTAMP,
        dataflowLexerWoAnno.INTEGRAL,
        dataflowLexerWoAnno.FRACTIONAL,
        dataflowLexerWoAnno.NUMBER,
        dataflowLexerWoAnno.ANY_SIMPLE
    ];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public static readonly keywordTokens: any[] = [
        dataflowLexerWoAnno.PARAMETERS,
        dataflowLexerWoAnno.FUNCTIONS,
        // dataflowLexerWoAnno.AS,
        dataflowLexerWoAnno.INPUT,
        dataflowLexerWoAnno.OUTPUT,
        dataflowLexerWoAnno.CONSTANT,
        dataflowLexerWoAnno.EXPRESSION,
        ...this.typeNameTokens
    ];
    public static readonly annotationName = {
        // do not use /*<space>, as we no longer skip WS in anno comments
        annotationHead: '/*',
        enableAnnotation: 'Annotation',
        implyMetafunction: 'MetaHead',
        implyTransientAssignment: 'TransientAssignmentHead',
        implyConfiguration: 'ConfigurationHead',
        implyGroup: 'GroupHead',
        // do not use <space>*/, as we no longer skip WS in anno comments
        annotationTail: '*/'
    };

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public static isBasicName(token: any) {
        return this.keywordTokens.includes(token.type) || token.type === dataflowLexerWoAnno.IDENTIFIER;
    }

    public static isPreprocessed(script: string) {
        return script.startsWith(this.annotationName.annotationHead + this.annotationName.enableAnnotation);
    }
}
